import { fork } from 'redux-saga/effects';
import { watchOrders } from './order/saga';
import { watchTours } from './tours/saga';
import { watchUser } from './user/saga';

export default function* rootSaga(): any {
  yield fork(watchTours);
  yield fork(watchOrders);
  yield fork(watchUser);
}
